"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchNFT = exports.buildTransferNFTTransaction = exports.fetchNFTByWallet = void 0;
var web3_js_1 = require("@solana/web3.js");
var spl_token_1 = require("@solana/spl-token");
var spl_token_2 = require("spl-token");
var helper_1 = require("../helper");
var fetchNFTByWallet = function (userAddress, connection, numberNFT) { return __awaiter(void 0, void 0, void 0, function () {
    var userTokens, filterTokens, nfts, filterNFTs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, connection.getParsedTokenAccountsByOwner(new web3_js_1.PublicKey(userAddress), {
                    programId: spl_token_1.TOKEN_PROGRAM_ID,
                })
                // filter token has decimals == 0 and token amount !== 0
            ];
            case 1:
                userTokens = _a.sent();
                filterTokens = userTokens.value.filter(function (item) {
                    var _a, _b;
                    var tokenAmount = (_b = (_a = item.account.data.parsed) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.tokenAmount;
                    return (tokenAmount === null || tokenAmount === void 0 ? void 0 : tokenAmount.amount) !== '0' && (tokenAmount === null || tokenAmount === void 0 ? void 0 : tokenAmount.decimals) === 0;
                }).map(function (item) { var _a, _b; return (_b = (_a = item.account.data.parsed) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.mint; });
                return [4 /*yield*/, Promise.all(filterTokens.map(function (item) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, (0, helper_1.fetchNFTDetail)(item, connection)];
                    }); }); }))];
            case 2:
                nfts = _a.sent();
                filterNFTs = nfts.filter(function (item) { return item !== null; });
                if (numberNFT) {
                    return [2 /*return*/, filterNFTs.slice(0, numberNFT)];
                }
                return [2 /*return*/, nfts.filter(function (item) { return item !== null; })];
        }
    });
}); };
exports.fetchNFTByWallet = fetchNFTByWallet;
var buildTransferNFTTransaction = function (fromAddress, toAddress, mintAddress, connection) { return __awaiter(void 0, void 0, void 0, function () {
    var fromPublicKey, toPublicKey, fromTokenAccount, toTokenAccount, recipientAccount, instructions, transaction, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                fromPublicKey = new web3_js_1.PublicKey(fromAddress);
                toPublicKey = new web3_js_1.PublicKey(toAddress);
                return [4 /*yield*/, (0, spl_token_2.getAssociatedTokenAddress)(new web3_js_1.PublicKey(mintAddress), fromPublicKey)];
            case 1:
                fromTokenAccount = _c.sent();
                return [4 /*yield*/, (0, spl_token_2.getAssociatedTokenAddress)(new web3_js_1.PublicKey(mintAddress), toPublicKey)];
            case 2:
                toTokenAccount = _c.sent();
                return [4 /*yield*/, (0, helper_1.getAccountInfo)(toTokenAccount, connection)];
            case 3:
                recipientAccount = _c.sent();
                instructions = [];
                if (!recipientAccount || !recipientAccount.isInitialized) {
                    instructions.push((0, spl_token_2.createAssociatedTokenAccountInstruction)(fromPublicKey, toTokenAccount, toPublicKey, new web3_js_1.PublicKey(mintAddress)));
                }
                instructions.push((0, spl_token_2.createTransferInstruction)(fromTokenAccount, // from (should be a token account)
                toTokenAccount, fromPublicKey, // from's owner
                1 // amount, if your deciamls is 8, send 10^8 for 1 token
                ));
                transaction = (_b = new web3_js_1.Transaction()).add.apply(_b, instructions);
                _a = transaction;
                return [4 /*yield*/, connection.getLatestBlockhash('finalized')];
            case 4:
                _a.recentBlockhash = (_c.sent()).blockhash;
                transaction.feePayer = fromPublicKey;
                return [2 /*return*/, transaction];
        }
    });
}); };
exports.buildTransferNFTTransaction = buildTransferNFTTransaction;
var FetchNFT = /** @class */ (function () {
    function FetchNFT(connection, userAddress) {
        var _this = this;
        this.fetchNFTList = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connection || !this.userAddress)
                            return [2 /*return*/, []];
                        return [4 /*yield*/, (0, exports.fetchNFTByWallet)(this.userAddress.toBase58(), this.connection)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.buildTransferTransaction = function (toAddress, mintAddress) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.connection || !this.userAddress)
                            return [2 /*return*/, undefined];
                        return [4 /*yield*/, (0, exports.buildTransferNFTTransaction)(this.userAddress.toBase58(), toAddress, mintAddress, this.connection)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.connection = connection;
        this.userAddress = userAddress;
    }
    return FetchNFT;
}());
exports.FetchNFT = FetchNFT;
